import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'jQbxuk',
    defaultMessage: 'Activate Account',
    description: 'Title for the WWEX carrier activation modal',
  },
  modalSubtitle: {
    id: '2djX76',
    defaultMessage: 'Confirm your details to activate freight shipping powered by Worldwide Express.',
    description: 'Subtitle for the WWEX carrier activation modal summary view',
  },
  cancelButton: {
    id: 'hHNj31',
    defaultMessage: 'Cancel',
    description: 'Cancel button text',
  },
  backButton: {
    id: 'Ii/Osr',
    defaultMessage: 'Back',
    description: 'Back button text on a WWEX registration sub-view, returns to the summary view',
  },
  saveButton: {
    id: '3AF0g8',
    defaultMessage: 'Save',
    description: 'Save button text on a WWEX registration sub-view',
  },
  submitButton: {
    id: 'ybvObQ',
    defaultMessage: 'Activate',
    description: 'Submit button text to activate the freight carrier',
  },
  editAccountInfoTitle: {
    id: 'H0JvvC',
    defaultMessage: 'Edit Account Information',
    description: 'Title for the Edit Account Information sub-view',
  },
  editBillingAddressTitle: {
    id: 'OmzZru',
    defaultMessage: 'Edit Billing Address',
    description: 'Title for the Edit Billing Address sub-view',
  },
  addPaymentMethodTitle: {
    id: '4PmWFl',
    defaultMessage: 'Add Payment Method',
    description: 'Title for the Add Payment Method sub-view',
  },
  // User Information Section
  userInfoSectionTitle: {
    id: 'd3TiUp',
    defaultMessage: 'Your Information',
    description: 'Section title for user information',
  },
  firstNameLabel: {
    id: 'paSL6e',
    defaultMessage: 'First Name',
    description: 'Label for first name field',
  },
  lastNameLabel: {
    id: 'NlrmyX',
    defaultMessage: 'Last Name',
    description: 'Label for last name field',
  },
  titleLabel: {
    id: 'wTEb4t',
    defaultMessage: 'Job Title',
    description: 'Label for job title field',
  },
  titlePlaceholder: {
    id: 'z+4CE3',
    defaultMessage: 'e.g., Operations Manager',
    description: 'Placeholder for job title field',
  },
  emailLabel: {
    id: 'bGKAyO',
    defaultMessage: 'Email',
    description: 'Label for email field',
  },
  emailPlaceholder: {
    id: 'sAnnHc',
    defaultMessage: 'Enter your email address',
    description: 'Placeholder for email field',
  },
  companyNameLabel: {
    id: 'bUuJB8',
    defaultMessage: 'Company Name',
    description: 'Label for company name field',
  },
  companyNamePlaceholder: {
    id: 'ln9c/T',
    defaultMessage: 'Enter your company name',
    description: 'Placeholder for company name field',
  },
  phoneNumberLabel: {
    id: 'PTLFMP',
    defaultMessage: 'Phone Number',
    description: 'Label for phone number field',
  },
  phoneNumberPlaceholder: {
    id: 'C+XQLG',
    defaultMessage: 'Enter your phone number',
    description: 'Placeholder for phone number field',
  },

  // Terms and Conditions
  termsSectionTitle: {
    id: 'A+mvcW',
    defaultMessage: 'Terms and Conditions',
    description: 'Section title for terms and conditions',
  },
  termsLabel: {
    id: 'Ye07w0',
    defaultMessage: 'I accept the terms and conditions',
    description: 'Label for terms acceptance checkbox',
  },
  termsRequiredError: {
    id: 'vGCg0S',
    defaultMessage: 'You must accept the terms and conditions to continue',
    description: 'Error message when terms are not accepted',
  },

  // Auctane Pay Account Section
  paymentMethodSectionTitle: {
    id: '/EnB4W',
    defaultMessage: 'Select Payment Method',
    description: 'Section title for payment method',
  },
  auctanePayAccountLabel: {
    id: 'mrhG/E',
    defaultMessage: 'Payment Method',
    description: 'Label for Auctane Pay account select',
  },
  auctanePayAccountPlaceholder: {
    id: 'Derj5u',
    defaultMessage: 'Select an Auctane Pay account',
    description: 'Placeholder for Auctane Pay account select',
  },
  auctanePayAccountEmptyState: {
    id: 'NI/wqw',
    defaultMessage: 'No payment methods available. Please add a payment method in Settings.',
    description: 'Message shown when user has no payment methods',
  },
  auctanePayAccountLoadError: {
    id: 'WpJpgu',
    defaultMessage: 'Failed to load payment methods. Please try again.',
    description: 'Error message when payment methods fail to load',
  },
  auctanePayAccountRequired: {
    id: 'RGKPpB',
    defaultMessage: 'Please select a payment method',
    description: 'Validation error for required payment method',
  },

  // Auto Pay Acceptance
  autoPayLabel: {
    id: 'pKEH+J',
    defaultMessage: 'I authorize automatic payments for shipping charges',
    description: 'Label for auto pay acceptance checkbox',
  },
  autoPayDescription: {
    id: '1+eSWQ',
    defaultMessage:
      'By checking this box, you authorize ShipStation to automatically charge your selected payment method for all shipping costs incurred through your WWEX account.',
    description: 'Description of auto pay terms',
  },
  autoPayRequiredError: {
    id: 'ObEwUd',
    defaultMessage: 'You must accept automatic payments to continue',
    description: 'Error message when auto pay is not accepted',
  },

  // Address Section Titles
  billingAddressSectionTitle: {
    id: 'hs5V37',
    defaultMessage: 'Billing Address',
    description: 'Section title for billing address fields',
  },
  shippingAddressSectionTitle: {
    id: '5poxRx',
    defaultMessage: 'Shipping Address',
    description: 'Section title for shipping address fields',
  },

  // Address Field Labels
  streetAddressLabel: {
    id: '1ZmJ3G',
    defaultMessage: 'Street Address',
    description: 'Label for street address line 1',
  },
  streetAddress2Label: {
    id: 'a/k25d',
    defaultMessage: 'Street Address Line 2',
    description: 'Label for street address line 2 (optional)',
  },
  cityLabel: {
    id: 'Xw/VVZ',
    defaultMessage: 'City',
    description: 'Label for city input',
  },
  stateLabel: {
    id: '5v+pWH',
    defaultMessage: 'State',
    description: 'Label for state dropdown',
  },
  zipCodeLabel: {
    id: 'c3ii9n',
    defaultMessage: 'ZIP Code',
    description: 'Label for ZIP/postal code input',
  },
  countryLabel: {
    id: 'WX3NeV',
    defaultMessage: 'Country',
    description: 'Label for country dropdown',
  },

  // Shipping Address
  sameAsBillingLabel: {
    id: '+aVGbh',
    defaultMessage: 'Same as billing address',
    description: 'Checkbox label to copy billing address to shipping',
  },

  // Validation Errors
  requiredFieldError: {
    id: 'dZCv1I',
    defaultMessage: 'This field is required',
    description: 'Error message for required fields',
  },
  invalidPhoneError: {
    id: 'lTFoNL',
    defaultMessage: 'Please enter a valid phone number (10-15 digits)',
    description: 'Error message for invalid phone number',
  },
  invalidEmailError: {
    id: 'N0LR2N',
    defaultMessage: 'Please enter a valid email address',
    description: 'Error message for invalid email',
  },

  // Success/Error Notifications
  successNotification: {
    id: 'qnxMJW',
    defaultMessage: 'SpeedShip carrier account created successfully! You can now use this carrier for freight shipping.',
    description: 'Success notification after account creation',
  },
  manageAccountLink: {
    id: 'xjWdqJ',
    defaultMessage: 'Manage',
    description: 'Link text in the WWEX registration success notification, navigates to the freight providers settings tab',
  },
  errorNotification: {
    id: 'NmyEVT',
    defaultMessage: 'Failed to create WWEX account. Please try again.',
    description: 'Error notification when account creation fails',
  },
  registrationFailedWithMessage: {
    id: 'RVFjm+',
    defaultMessage: 'Registration failed: {errorMessage}',
    description: 'Error notification when registration fails with a specific error message',
  },
  registrationFailedWithSupport: {
    id: 'wrv/79',
    defaultMessage: 'Registration failed: {errorMessage}. Please try again or contact support.',
    description: 'Error notification when registration fails unexpectedly with support contact info',
  },
  unexpectedErrorOccurred: {
    id: 'l1onmJ',
    defaultMessage: 'An unexpected error occurred',
    description: 'Generic error message for unexpected errors',
  },
  paymentMethodUpdateError: {
    id: 'HicltZ',
    defaultMessage: 'Failed to update payment method billing address',
    description: 'Error notification when payment method billing address update fails',
  },
  paymentMethodCreationError: {
    id: 'T1XCVh',
    defaultMessage: 'Failed to create payment method',
    description: 'Error notification when payment method creation fails',
  },
  paymentMethodFetchError: {
    id: '5AfFaA',
    defaultMessage: 'Failed to fetch updated payment method details',
    description: 'Error notification when fetching payment method details fails',
  },

  // Payment Method
  addNewPaymentMethodOption: {
    id: '461BB2',
    defaultMessage: '+ Add Payment Method',
    description: 'Dropdown option to add a new payment method',
  },
  billingAddressModifiedNote: {
    id: 'jmqUkk',
    defaultMessage: 'Note: Changing the billing address will update this payment method for all future transactions.',
    description: 'Warning note shown when billing address is modified',
  },
  paymentFormNotReady: {
    id: 'LCMRJr',
    defaultMessage: 'Payment form is not ready. Please try again.',
    description: 'Error message when payment form is not ready for submission',
  },
});
